import React, { useCallback } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import GroupRemoveIcon from "@mui/icons-material/GroupRemove";

import CancelIcon from "@mui/icons-material/Cancel";
import toast from "react-hot-toast";
import {
  deleteRunningClub,
  getAllRunningsClubsOfProvider,
} from "../../../../services/rest/runningsClubs/runningClubsProviderService";
import { useDispatch } from "react-redux";
import { setRunningsClubsOfCoach } from "../../../../redux/slice/runningsClubsSlice";

function createData(
  _id,
  nameRunningClub,
  trainingDays,
  level,
  typeTraining,
  urlImg,
  location
) {
  return {
    _id,
    nameRunningClub,
    trainingDays,
    level,
    typeTraining,
    urlImg,
    location,
  };
}

const ModalDeleteClub = ({
  open,
  selectedClub,
  setShowModalDelete,
  setLoading,
  setListClubs,
}) => {
  const handleClose = useCallback(() => {
    setShowModalDelete(false);
  }, [setShowModalDelete]);
  const dispatch = useDispatch();

  const deleteClub = async () => {
    try {
      setLoading(true);
      //Se hace la peticion a la API de elimin club y se hace peticion a la API de eliminar clubes y se actualiza lista de comunidades
      await deleteRunningClub(selectedClub?._id);

      const listResponse = await getAllRunningsClubsOfProvider();

      dispatch(
        setRunningsClubsOfCoach({
          runningsClubsOfCoach: listResponse ?? [],
        })
      );
      handleClose();

      toast.success("Se eliminó correctamente  club");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("En estos momentos no se puede eliminar  club.");
    }
  };
  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle>
          <Typography sx={{ textAlign: "center" }}>
            ¿Estas seguro de eliminar a {selectedClub?.nameRunningClub} de tus
            Clubs?
          </Typography>
        </DialogTitle>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            // onClick={handleClose}
            sx={{ borderColor: "white", color: "white" }}
            startIcon={<GroupRemoveIcon />}
            onClick={deleteClub}
          >
            Eliminar Club
          </Button>
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{ backgroundColor: "#e7ef7d" }}
            startIcon={<CancelIcon />}
          >
            Cerrar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDeleteClub;
